import * as CL from '@design-system/component-library';
import { firstNameMsg, lastNameMsg, t } from '../../../common/i18n/index.js';
import { Email, Name, PhoneNumber } from '../../../common/react-hook-form/fields/index.js';
import { GridColumn } from '../../BillingAccountDetails/components/GridColumn.js';

interface CreateContactProps {
  fieldPrefix?: string;
  isEmailMandatory?: boolean;
  isPhoneNumberMandatory?: boolean;
}
export const CreateContact = ({
  fieldPrefix = '',
  isEmailMandatory = true,
  isPhoneNumberMandatory = true,
}: CreateContactProps) => (
  <>
    <CL.Grid>
      <CL.GridRow className="of-purpose-of-use__grid_row">
        <GridColumn className="of-purpose-of-use__grid_col">
          <Name
            name={`${fieldPrefix}firstName`}
            label={t.AIK7(firstNameMsg)}
            placeholder={t.AIK7(firstNameMsg)}
            required={true}
          />
        </GridColumn>
        <GridColumn className="of-purpose-of-use__grid_col">
          <Name
            name={`${fieldPrefix}lastName`}
            label={t.Y41S(lastNameMsg)}
            placeholder={t.Y41S(lastNameMsg)}
            required={true}
          />
        </GridColumn>
      </CL.GridRow>
      <CL.GridRow className="of-purpose-of-use__grid_row">
        <GridColumn className="of-purpose-of-use__grid_col">
          <PhoneNumber name={`${fieldPrefix}phoneNumber`} required={isPhoneNumberMandatory} />
        </GridColumn>
        <GridColumn className="of-purpose-of-use__grid_col">
          <Email name={`${fieldPrefix}email`} required={isEmailMandatory} />
        </GridColumn>
      </CL.GridRow>
    </CL.Grid>
  </>
);
